import { Clock3, AlertTriangle, CheckCircle2 } from "lucide-react";

const ROWS = [
  {
    icon: CheckCircle2,
    notice: "24 hours or more notice",
    fee: "No charge",
    tone: "text-primary",
  },
  {
    icon: Clock3,
    notice: "Less than 24 hours notice",
    fee: "50% of the session fee",
    tone: "text-primary",
  },
  {
    icon: AlertTriangle,
    notice: "Less than 2 hours notice or no show",
    fee: "100% of the session fee",
    tone: "text-destructive",
  },
];

/** Current published version of the cancellation policy, stored with each booking. */
export const CANCELLATION_POLICY_VERSION = "2026-08-26";

/** Compact, responsive cancellation and late appointment policy card. */
export function CancellationPolicy({ className = "" }: { className?: string }) {
  return (
    <section
      aria-labelledby="cancellation-policy-heading"
      className={`rounded-2xl border border-border bg-card p-5 shadow-sm sm:p-6 ${className}`}
    >
      <h2 id="cancellation-policy-heading" className="font-display text-base font-bold text-primary sm:text-lg">
        Cancellation &amp; late appointment policy
      </h2>
      <p className="mt-1 text-sm text-muted-foreground">
        Please let us know as early as possible if your plans change.
      </p>

      <ul className="mt-4 divide-y divide-border rounded-xl border border-border/70">
        {ROWS.map((r) => (
          <li key={r.notice} className="flex items-start justify-between gap-3 p-3 sm:items-center sm:p-4">
            <span className="flex items-start gap-2 text-sm text-foreground/85 sm:items-center">
              <r.icon className={`mt-0.5 h-4 w-4 shrink-0 sm:mt-0 ${r.tone}`} aria-hidden />
              {r.notice}
            </span>
            <span className={`shrink-0 text-right text-sm font-semibold ${r.tone}`}>{r.fee}</span>
          </li>
        ))}
      </ul>

      <p className="mt-4 text-xs leading-relaxed text-muted-foreground">
        Appointments cancelled less than 2 hours before the scheduled time are charged at the full session fee because
        we are unable to fill the appointment slot at such short notice.
      </p>
    </section>
  );
}
